<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="../../assets/imgs/wuhou/5/base.png" alt="" />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img class="top" src="../../assets/imgs/125/desc-title.png" alt="" />
          <div class="content">
            为进一步发挥猎头机构引才引智作用，精准引进海内外高层次人才，根据《武侯区创建区域创新人才高地特色区的若干政策措施》，制定本细则。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="../../assets/imgs/wuhou/5/title1.png" alt="" />
          <div class="content" style="background-color: #fff">
            介绍引进区外高层次人才来武侯区工作的、合法经营的人力资源服务机构。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="../../assets/imgs/wuhou/5/title2.png" alt="" />
          <div class="content" style="background-color: #d4e0ff">
            <div class="des" style="margin-top: 0.1rem">
              <div>
                （一）机构介绍引进的高层次人才符合《成都市人才分类目录》条件的A、B、C、D类人才。<br/>
                1.介绍A类人才，每引进1名奖励30万元。<br/>
                2.介绍B类人才，每引进1名奖励10万元。<br/>
                3.介绍C类人才，每引进1名奖励5万元。<br/>
                4.介绍D类人才，每引进1名奖励2万元。<br/>
                介绍引进高层次人才的机构引进每名高层次人才，只能选择享受以上其中一项奖励。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （二）机构介绍引进的高层次人才应当为首次到武侯区内企事业单位就业，须与具有独立法人资格、登记注册和纳税关系在武侯区的企事业单位签订3年以上具有法律效力的劳动（聘用）合同，按规定在武侯区缴纳社会保险，在武侯区工作满1年后可申报本奖励。其中，到事业单位就业的，须将人事关系转入武侯区。高层次人才在武侯区工作起始时间从正式签订并履行劳动（聘用）合同之日起算；到事业单位就业的，从人事关系转入单位之日起算。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （三）介绍引进高层次人才不含本单位或系统内部跨城市、跨区域调动，以及机关事业单位招考等到武侯区的高层次人才。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （四）机构对介绍引进每名高层次人才，只能选择1家企事业单位进行申报，已享受过本政策的不重复申报。
              </div>
            </div>
            <div class="des" style="margin-top: 0.2rem">
              <div>
                （五）机构无重大违规违法行为和严重失信行为。
              </div>
            </div>
          </div>
        </div>
        <div class="part-four">
          <img
            src="../../assets/imgs/wuhou/5/title3.png"
            class="part-two-title-img"
          />
          <div class="main-content">
            <div class="part-four-items">
              <div class="title-bg">申报</div>
              <div class="part-four-content1">
                机构按照要求填写申报信息，准备申报材料，经引进高层次人才的企事业单位核实后，按照属地管理的原则，向所属街道申报。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg2">
                <div class="extendFont">初审</div>
              </div>
              <div class="part-four-content1">
                所属街道负责对申报材料、条件等进行初审，必要时进行实地考察，并出具审核意见，将审核意见和申报材料报区人社局。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg3">复审</div>
              <div class="part-four-content1">
                区人社局对申报材料进行复审，审核通过名单报区人社局党组审定。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg4">公示</div>
              <div class="part-four-content1">
                区人社局将区委人才工作领导小组审定的结果公示5个工作日。
              </div>
            </div>
            <div class="part-four-items" style="border: none">
              <div class="title-bg title-bg5">拨付</div>
              <div class="part-four-content1">对公示无异议的，区人社局按照程序拨付资金给申领单位。</div>
            </div>
          </div>
        </div>
        <div class="contact" style="margin-top: 0.3rem">
          <img class="top" src="../../assets/imgs/wuhou/1/title4.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-85176231">028-85176231</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              武侯区人社局
            </div>
          </div>
        </div>
        <!-- <div class="codes">
          <img class="info" src="../../assets/imgs/147/code.png" />
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.circle {
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 50%;
  border: 0.06rem solid #ff6d60;
  margin-right: 0.08rem;
}
.commonCircle {
  display: flex;
  align-items: center;
  margin: 0.19rem 0;
  &-circle {
    width: 0.2rem;
    height: 0.2rem;
    border-radius: 50%;
    border: 0.06rem solid #ff6d60;
    flex-shrink: 0;
  }
  &-font {
    font-size: 0.34rem;
    color: #333;
    font-weight: 600;
  }
}
.part-four {
  width: 6.85rem;
  background: #e8eeff;
  border-radius: 10px;
  margin-left: 0.02rem;
  margin-top: 0.22rem;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 0.22rem;
  border: 0.00001px solid transparent;
  position: relative;
  padding: 1.2rem 0.25rem 0 0.25rem;
  .part-two-title-img {
    width: 7.03rem;
    height: 1.37rem;
    top: 0;
    left: -0.2rem;
    position: absolute;
  }
  .main-content {
    margin-top: 0.34rem;
    width: 6.35rem;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    padding-top: 0.9rem;
    padding-left: 0.35rem;
    padding-right: 0.31rem;

    .part-four-items {
      box-sizing: border-box;
      border-left: 0.02rem dashed #739bfe;
      margin-bottom: 0.6rem;
      padding-left: 0.33rem;
      padding-top: 0.2rem;
      position: relative;
      font-size: 0.26rem;
      // //font-family:: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #4e4e4e;
      line-height: 0.44rem;
      text-align: left;
      padding-bottom: 0.35rem;

      .title-bg {
        position: absolute;
        width: 3.31rem;
        height: 0.55rem;
        top: -0.6rem;
        left: -0.25rem;
        line-height: 0.55rem;
        font-size: 0.34rem;
        font-weight: bold;
        color: #3d5aa3;
        padding-left: 0.58rem;
        background: url(../../assets/imgs/144/p1.png) 0 0/100% 100%;
        border: 1px solid #fff;
      }

      .title-bg2 {
        background: url(../../assets/imgs/144/p2.png) 0 0/100% 100%;
      }

      .extendFont {
        min-width: 7rem;
        position: absolute;
        top: 50%;
        left: 0.58rem;
        transform: translateY(-50%);
      }

      .title-bg3 {
        background: url(../../assets/imgs/144/p3.png) 0 0/100% 100%;
      }

      .title-bg4 {
        background: url(../../assets/imgs/144/p4.png) 0 0/100% 100%;
      }

      .title-bg5 {
        background: url(../../assets/imgs/144/p5.png) 0 0/100% 100%;
      }

      .title-bg6 {
        background: url(../../assets/imgs/144/p6.png) 0 0/100% 100%;
      }

      .inside-title {
        font-weight: 800;
      }

      .part-four-content2 {
        font-weight: bolder;
      }
    }
  }
}
.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;
  overflow: hidden;
  .top-img {
    width: 7.26rem;
    // height: 4.73rem;
  }

  .technological-process {
    transform: translateY(-2rem);

    .rhtj {
      position: relative;

      .top {
        width: 6.86rem;
        height: 2.12rem;
      }

      .content {
        width: 6.85rem;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        background: #ffffff;
        font-size: 0.26rem;
        color: #4e4e4e;
        text-align: left;
        position: relative;
        font-weight: 500;
        line-height: 0.44rem;
      }
    }

    .zccl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          position: relative;
          text-align: left;
          margin-top: 0.8rem;
          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            min-width: 3.74rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.86rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .circle-box {
          font-size: 0.34rem;
          color: #333;
          font-weight: bold;
          padding-top: 0.5rem;
          text-align: left;
          position: relative;
          .circle {
            width: 0.28rem;
            height: 0.28rem;
            border: 0.06rem solid #ff6d60;
            border-radius: 50%;
            flex-shrink: 0;
            box-sizing: border-box;
            position: absolute;
            left: 0;
            top: 0.62rem;
            display: inline-block;
          }
          .circle-txt {
            text-indent: 1.1em;
          }
        }

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 130%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 4.4rem;
              height: 0.55rem;
              background-image: url(../../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.1rem;

              .line-num {
                width: 0.44rem;
                height: 0.44rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.18rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .info {
        width: 6.42rem;
        height: 1.94rem;
      }
    }
  }
}
</style>
